/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineNuxtPlugin } from 'nuxt/app';

export default defineNuxtPlugin(nuxtApp => {
  const i18n = nuxtApp.$i18n as { t: (key: string, ...args: any[]) => string };
  const originalT = i18n.t;

  // eslint-disable-next-line id-length
  i18n.t = (key: any, ...args: any) => {
    let translation = originalT.apply(this, [key ?? '', ...args]);

    translation = decodeHtml(translation);

    return translation;
  };
});
